import { CSSProperties, ReactNode } from 'react';

import { Mask } from 'antd-mobile';
import styled from 'styled-components';

interface CalendarMaskProps {
  children: ReactNode;
  visible: boolean;
  onClose: () => void;
  style?: CSSProperties;
}

export const CalendarMask = (props: CalendarMaskProps) => {
  const { children, visible, onClose, style } = props;
  return (
    <>
      <Mask visible={visible} onMaskClick={onClose} destroyOnClose>
        <Modal style={{ ...style }}>{children}</Modal>
      </Mask>
    </>
  );
};

const Modal = styled.div`
  position: absolute;
  background: #ffffff;
  top: 30%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 270px;
  flex-direction: column;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 6px;
  overflow: hidden;
`;
